<template>
  <div class="job-teacher-page">
    <!-- 页面标题 -->
    <div class="page-header">
      <div class="title-line">
        <span class="line"></span>
        <span class="title">年级组长</span>
      </div>
    </div>

    <!-- 表格：学段 + 年级 → 现在只展示 学段 + 年级组长 -->
    <el-table
      :data="gradeList"
      border
      style="width: 100%;"
      class="job-table"
    >
      <!-- 年级列 -->
      <el-table-column label="年级" align="center" prop="gradeName" min-width="120" />

      <!-- 年级组长 -->
      <el-table-column label="年级组长" align="center">
        <template slot-scope="scope">
          <el-button
            type="text"
            class="teacher-btn"
            @click="openSetDialog(scope.row.grade)"
          >
            {{ getGradeLeader(scope.row.grade) || '设置' }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 设置年级组长弹窗 -->
    <el-dialog title="设置年级组长" :visible.sync="dialogVisible" width="550px" :append-to-body="true"
		  	:loading="dialogLoading">
      <!-- 搜索选择教师 -->
      <el-select
        v-model="selectedTeacherId"
        placeholder="请选择教师"
        filterable
        remote
        :remote-method="searchTeacher"
        style="width: 100%; margin-bottom: 15px;"
        clearable
      >
        <el-option
          v-for="teacher in teacherList"
          :key="teacher.id"
          :label="teacher.name"
          :value="teacher.id"
        ></el-option>
      </el-select>

      <!-- 已选教师 -->
      <div v-if="selectedTeacherId" style="padding: 10px; background: #f7f8fa; border-radius: 6px;">
        已选教师：<b>{{ getSelectedName() }}</b>
        <el-button type="success" size="mini" @click="saveTeacher" style="margin-left: 10px;">
          确认保存
        </el-button>
      </div>

      <!-- 当前组长列表 -->
      <div style="margin-top: 15px;">
        <div style="font-weight: bold; margin-bottom: 8px;">当前年级组长：</div>
        <el-tag
          v-for="item in currentLeaderList"
          :key="item.id"
          type="primary"
          closable
          @close="deleteLeader(item.id)"
          style="margin-right: 8px; margin-bottom: 8px;"
        >
          {{ item.teacherName }}
        </el-tag>
        <div v-if="currentLeaderList.length === 0" style="color: #999;">暂无年级组长</div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "JobGradeLeader",
  data() {
    return {
      dialogVisible: false,
      teacherList: [],
      selectedTeacherId: null,
      schoolId: localStorage.getItem('orgId'),
      schoolInfo: {},
      currentLeaderList: [],
      currentGradeId: null,
      currentSection: null,

      // 学段
      stageList: [
        { label: '小学', value: 1 },
        { label: '初中', value: 2 },
        { label: '高中', value: 3 }
      ],

      gradeList: [],
      // 年级组长映射：gradeId -> 教师名
      gradeLeaderMap: {},
      login: null,
    };
  },
  computed: {
    stageListFiltered() {
      if (!this.schoolInfo.stages) return []
      return this.stageList.filter(item =>
        this.schoolInfo.stages.includes(item.value.toString())
      )
    }
  },
  created() {
    this.getSchoolInfo();
  },
  methods: {
    loginOpen(text) {
      this.login = this.$loading({
        lock: true,
        text: text,
        zIndex: 100001,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    noLogin() {
      if (this.login) {
        this.login.close()
        this.login = null;
      }
    },

    // 获取学校信息
    getSchoolInfo() {
      this.loginOpen('加载中...')
      this.API.get(this.API.school.getSchoolId + this.schoolId).then(res => {
        if (res.data.code == 200) {
          this.schoolInfo = res.data.data;
          if (this.stageListFiltered.length > 0) {
            this.selectSection(this.stageListFiltered[0].value);
          }
        }
        this.noLogin()
      }).catch(() => {
        this.noLogin()
      })
    },

    // 切换学段 → 加载年级
    selectSection(sectionVal) {
      this.currentSection = sectionVal;
      this.loadGradeBySection(sectionVal);
    },

    // 根据学段加载年级
    loadGradeBySection(sectionVal) {
      this.loginOpen('年级加载中...')
      this.API.get(this.API.school.getSchoolGrad, {
        schoolId: this.schoolId
      }).then(res => {
        var list = res.data.data || [];
        this.gradeList = list;
        this.$nextTick(() => {
          this.loadAllGradeLeaders();
        })
        this.noLogin()
      }).catch(() => {
        this.noLogin()
      })
    },

    // ===================== 核心：加载所有年级组长 =====================
    loadAllGradeLeaders() {
      this.API.get(this.API.school.getSchoolGradeLeaderList, {
        schoolId: this.schoolId,
        sectionId: this.currentSection,
        roleType: 5
      }).then(res => {
        if (res.data.code === 200) {
          const list = res.data.data || [];
          const map = {};
          list.forEach(item => {
            const key = item.gradeId;
            map[key] = item.teacherName;
          });
          this.gradeLeaderMap = map;
        }
      })
    },

    // 获取表格显示的年级组长
    getGradeLeader(gradeId) {
      return this.gradeLeaderMap[gradeId];
    },

    // 打开弹窗
    openSetDialog(gradeId) {
      this.loginOpen('加载中...')
      this.currentGradeId = gradeId;
      this.selectedTeacherId = null;

      // 查询当前年级组长
      this.API.get(this.API.school.getSchoolGradeLeaderList, {
        schoolId: this.schoolId,
        gradeId: gradeId,
        roleType: 5
      }).then(res => {
        if (res.data.code == 200) {
          this.currentLeaderList = res.data.data;
          this.dialogVisible = true;
        }
        this.noLogin()
      }).catch(() => {
        this.noLogin()
      })
    },

    // 搜索教师
    searchTeacher(key) {
      this.loginOpen('查询教师中...')
      const name = key || '';
      this.API.get(this.API.school.getSchoolSearch, {
        pageNum: 1,
        pageSize: 100,
        schoolId: this.schoolId,
        name: name
      }).then(res => {
        this.teacherList = res.data.data.records;
        this.noLogin()
      }).catch(() => {
        this.noLogin()
      })
    },

    getSelectedName() {
      const t = this.teacherList.find(u => u.id == this.selectedTeacherId);
      return t ? t.name : "";
    },

    // 保存
    saveTeacher() {
      if (!this.selectedTeacherId) {
        return this.$message.warning("请选择教师");
      }
      this.loginOpen('设置中...')
      const params = {
        userId: this.selectedTeacherId,
        schoolId: this.schoolId,
        roleType: 5,
        gradeId: this.currentGradeId,
        sectionId: this.currentSection
      };

      this.API.post(this.API.school.postAssignSave, params).then(res => {
        if (res.data.code === 500) {
          this.$message.error(res.data.msg);
        } else {
          this.$message.success("设置成功");
          this.loadAllGradeLeaders();
          this.openSetDialog(this.currentGradeId);
          this.selectedTeacherId = null;
        }
        this.noLogin()
      }).catch(() => {
        this.noLogin()
      })
    },

    // 删除
    deleteLeader(id) {
      this.loginOpen('取消中...')
      this.API.deleted(this.API.school.deletedAssign + id).then(() => {
        this.$message.success("已取消");
        this.loadAllGradeLeaders();
        this.openSetDialog(this.currentGradeId);
        this.noLogin()
      }).catch(() => {
        this.noLogin()
      })
    }
  }
};
</script>

<style scoped>
.job-teacher-page {
	width: calc(60vw);
  padding: 15px;
}

.page-header {
  margin-bottom: 20px;
}

.title-line {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.line {
  display: inline-block;
  width: 3px;
  height: 16px;
  background-color: #1e88e5;
  margin-right: 8px;
}

.title {
  font-size: 14px;
  font-weight: bold;
  color: #333;
}

.job-table /deep/ th {
  background-color: #1e88e5;
  color: #fff;
}

/deep/ .el-button--text {
  color: #1e88e5;
}

.teacher-btn {
  max-width: 100%;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}
</style>